(function () {
  'use strict';
  const initialized = new WeakMap();
  const bindings = new Set();
  const selections = new Map();

  function waitForCart(method) {
    if (typeof window.starblizBundleCart?.[method] === 'function') return Promise.resolve(window.starblizBundleCart);
    return new Promise((resolve, reject) => {
      const ready = () => {
        if (typeof window.starblizBundleCart?.[method] !== 'function') return;
        clearTimeout(timeout);
        document.removeEventListener('starbliz:cart-ready', ready);
        resolve(window.starblizBundleCart);
      };
      const timeout = setTimeout(() => {
        document.removeEventListener('starbliz:cart-ready', ready);
        reject(new Error('Der Warenkorb ist noch nicht bereit. Bitte versuche es erneut.'));
      }, 15000);
      document.addEventListener('starbliz:cart-ready', ready);
      ready();
    });
  }

  function setup(block) {
    const section = block.closest('[id^="shopify-section-"]');
    const input = section?.querySelector('.sticky--product-quantity input[name="quantity"]');
    if (!input?.form || !block.querySelector('input[type="radio"]')) return;
    if (initialized.get(block)?.input === input) return;
    initialized.get(block)?.controller.abort();
    let data;
    try { data = JSON.parse(block.getAttribute('deal-block')); } catch (_) { return; }
    const deals = data.dealBars?.filter(d => d.dealBarType === 'quantity-break');
    if (![1, 2, 4].every(q => deals?.some(d => Number(d.quantity) === q))) return;
    const controller = new AbortController();
    const binding = {block, input, controller};
    initialized.set(block, binding);
    bindings.add(binding);
    const listen = {signal: controller.signal};
    const selectionKey = block.getAttribute('current-variant-id') || input.form.querySelector('[name="id"]')?.value;
    let total = selections.get(selectionKey) ?? Math.max(1, Number(input.value) || 1);
    input.value = total;
    let syncing = false;
    let adding = 0;
    let release;
    const note = document.createElement('p');
    note.setAttribute('role', 'status');
    note.style.cssText = 'font-size:13px;line-height:1.5;margin:8px 0;color:inherit';
    note.hidden = true;
    block.after(note);

    function selected() {
      const value = block.querySelector('input[type="radio"]:checked')?.value;
      return deals.find(d => d.id === value);
    }
    function show() {
      input.value = String(total);
      const base = total >= 4 ? 4 : total >= 2 ? 2 : 1;
      section.querySelectorAll('.shopify-payment-button').forEach(button => { button.style.display = total > base ? 'none' : ''; });
      note.hidden = total <= base;
      note.textContent = total > base ? `${base} im Angebot + ${total - base} zum regulären Preis` : '';
    }
    function fromInput() {
      if (syncing) return;
      const desired = Number(input.value);
      if (!Number.isSafeInteger(desired) || desired < 1 || !input.checkValidity()) return;
      total = desired;
      selections.set(selectionKey, total);
      const base = total >= 4 ? 4 : total >= 2 ? 2 : 1;
      const deal = deals.find(d => Number(d.quantity) === base);
      const radio = Array.from(block.querySelectorAll('input[type="radio"]')).find(r => r.value === deal.id);
      syncing = true;
      if (!radio.checked) radio.click();
      clearTimeout(release);
      queueMicrotask(() => { show(); syncing = false; });
      show();
    }
    function fromBundle(event) {
      if (syncing || !event?.isTrusted) return;
      total = Number(selected()?.quantity) || 1;
      selections.set(selectionKey, total);
      show();
    }
    document.addEventListener('starbliz:cart-updated', show, listen);
    input.addEventListener('input', fromInput, listen);
    input.addEventListener('change', fromInput, listen);
    block.addEventListener('click', event => {
      if (!event.isTrusted) event.stopPropagation();

    }, listen);
    window.addEventListener('click', event => {
      if (!event.isTrusted || !block.contains(event.target)) return;
      const bar = event.target.closest('.kaching-bundles__bar');
      const value = bar?.querySelector('input[type="radio"]')?.value;
      const deal = deals.find(d => d.id === value);
      if (!deal) return;
      total = Number(deal.quantity);
      selections.set(selectionKey, total);
      syncing = false;
      show();
    }, {capture:true, signal:controller.signal});
    block.addEventListener('change', fromBundle, listen);
    block.addEventListener('deal-bar-selected', fromBundle, listen);
    controller.signal.addEventListener('abort', () => { clearTimeout(release); note.remove(); }, {once:true});

    async function add(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (adding) return;
      clearTimeout(release);
      syncing = false;
      total = selections.get(selectionKey) ?? Math.max(1, Number(input.value) || total);
      if (!input.reportValidity()) return;
      const requestedTotal = total;
      const requestedVariant = input.form.querySelector('[name="id"]')?.value;
      adding++;
      const buttons = Array.from(input.form.querySelectorAll('[type="submit"]')).map(button => ({button, disabled:button.disabled, busy:button.getAttribute('aria-busy')}));
      buttons.forEach(({button}) => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
      let failure = '';
      try {
        const cart = await waitForCart('addSelection');
        if (!block.isConnected || !input.isConnected || requestedVariant !== input.form.querySelector('[name="id"]')?.value) return;
        await cart.addSelection(block, requestedTotal, input.form);
      } catch (error) { failure = error.message; }
      finally {
        adding--;
        if (!adding) buttons.forEach(({button, disabled, busy}) => { button.disabled = disabled; if (busy === null) button.removeAttribute('aria-busy'); else button.setAttribute('aria-busy', busy); });
        show();
        if (failure) { note.hidden = false; note.textContent = failure; }
      }
    }
    window.addEventListener('click', event => {
      if (!block.isConnected || !input.isConnected) return;
      const button = event.target.closest('button[type="submit"],input[type="submit"]');
      if (button?.form === input.form) add(event);
    }, {capture:true, signal:controller.signal});
    window.addEventListener('submit', event => {
      if (!block.isConnected || !input.isConnected) return;
      if (event.target === input.form) add(event);
    }, {capture:true, signal:controller.signal});
    fromInput();
  }
  function scan() {
    for (const binding of bindings) {
      if (!binding.block.isConnected || !binding.input.isConnected || binding.controller.signal.aborted) {
        binding.controller.abort();
        if (initialized.get(binding.block) === binding) initialized.delete(binding.block);
        bindings.delete(binding);
      }
    }
    document.querySelectorAll('kaching-bundles-block').forEach(setup);
  }
  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
